module.exports = __webpack_public_path__ + "static/media/calendar_month.8867a606.svg";